import PropTypes from 'prop-types'
import React from 'react'
import { List, Map } from 'immutable'
import toNumber from 'lodash/toNumber'
import _get from 'lodash/get'
import ImmutablePropTypes from 'react-immutable-proptypes'
import _parseInt from 'lodash/parseInt'
import { connect as connectRedux } from 'react-redux'
import { get as getConfig } from '../../config/index'
import MenuItem from '../MenuItem/index'
import UserAvatar from '../UserAvatar/index'
import { MENU_ITEM_ICON_TYPE_ARROW } from '../MenuItem/types'
import { getPrimary } from '../../services/languages/index'
import IconV2, { ICON_TYPES } from '../Icon.v2/index'
import { getBoundActions } from '../../actions/index'
import { createGaiaScreenModel } from '../../services/resolver/index'
import { createUpstreamContext, SCREEN_TYPE_HEADER } from '../../services/upstream-context/index'
import Link from '../Link/index'
import Button, { TYPES } from '../Button/index'
import {
  URL_GIFT_LP,
  URL_MARKETPLACE_LOGGED_IN,
} from '../../services/url/constants'
import { getGiftLpUrl } from '../../services/url/index'
import { GIFT_READY_STATE } from '../../services/gift/index'
import { getUserAvatarName } from '../../services/user/index'
import { getAuthIsLoggedIn } from '../../services/auth/index'
import { selectProfilePicturesMap } from '../../services/community/identity/profile/redux/selectors'

const config = getConfig()
const giftMultipleCurrenciesActive = !!_get(config, ['features', 'gift', 'multipleCurrencies'])

const CLASS_NAME_AVATAR = ['menu-item__avatar']

function getClass (
  isOwner,
  hasPortal,
) {
  const cls = ['menu-item__link menu-item__link--user']
  if (isOwner) cls.push('menu-item__link--owner')
  if (isOwner && hasPortal) cls.push('menu-item__link--owner-with-portal')
  return cls.join(' ')
}

class Menu extends React.Component {
  //
  onClick = (e) => {
    const { props } = this
    const { currentTarget } = e
    const index = currentTarget.getAttribute('data-index')
    const { menu } = props
    const item = menu.get(toNumber(index))

    if (item) {
      if (item.get('onClick')) {
        const clickFunc = item.get('onClick')
        clickFunc(e, item, props)
      }
      this.track()
    }
  }

  track () {
    const { props } = this
    const {
      clearUpstreamContext,
      // upstreamContext,
      contextType,
      language,
      resolver,
      auth,
      location,
    } = props

    if (contextType) {
      const gaiaScreen = createGaiaScreenModel({ resolver })
      const screenType = gaiaScreen.get('screenType', SCREEN_TYPE_HEADER)
      const screenParam = gaiaScreen.get('screenParam')
      const upstreamContext = createUpstreamContext({
        contextType,
        screenParam,
        screenType,
      })

      if (
        upstreamContext
        && upstreamContext.get('screenType')
        && upstreamContext.get('screenParam')
        && upstreamContext.get('contextType')
        && location
        && language
        && auth
      ) {
        clearUpstreamContext()
      }
    }
  }

  changeUser (profile) {
    const { props } = this
    const {
      toggleUserMenuVisible,
      resetOnboarding,
      changeAuthProfile,
      auth,
    } = props
    resetOnboarding()
    toggleUserMenuVisible()
    changeAuthProfile({
      userAccountId: profile.get('user_account_id'),
      uid: profile.get('uid'),
      auth,
    })
  }

  renderProfile (profile) {
    const { props } = this
    const {
      portalUrl, auth, staticTextViewPortal, staticTextMenu, toggleUserMenuVisible,
      trackCommunityHeaderLinkClicked,
    } = props

    const uid = auth.get('uid')
    const uuid = auth.get('uuid')
    const isOwner = _parseInt(profile.get('uid')) === uid
    const hasPortal = isOwner && portalUrl
    const url = hasPortal ? `/portal/${portalUrl}` : ''
    const onClick = hasPortal ? null : () => this.changeUser(profile)
    const { communityProfilePictures, communityProfileEnabled, communityDisplayName } = props
    const profileUid = String(profile.get('uid'))
    const profileEnabled = !!communityProfileEnabled
    const avatar = profileEnabled
      ? communityProfilePictures.getIn([profileUid, 'card'], '')
      : profile.getIn(['profilePicture', 'hdtv_190x266'], '')
    const className = getClass(isOwner, portalUrl)
    const profileName = (isOwner && profileEnabled && communityDisplayName)
      ? communityDisplayName
      : getUserAvatarName(profile)
    const children = [
      <UserAvatar
        className={CLASS_NAME_AVATAR}
        path={avatar}
        key="avatar"
        name={profileName}
      />,
      <span
        className="menu-item__profile-name"
        key="username"
      >{profileName}
      </span>,
    ]

    if (isOwner && profileEnabled) {
      return (
        <Link
          className={className}
          to={`/profile/${uuid}`}
          onClick={() => {
            if (trackCommunityHeaderLinkClicked) trackCommunityHeaderLinkClicked('user_menu')
            toggleUserMenuVisible()
          }}
        >
          <UserAvatar
            className={CLASS_NAME_AVATAR}
            path={avatar}
            key="avatar"
            name={profileName}
          />
          <span className="menu-item__owner-info">
            <span className="menu-item__profile-name--owner-community">{profileName}</span>
            <span className="menu-item__my-profile-row">
              {staticTextMenu.getIn(['user', 'myProfile'], 'My Profile')}
              <span className="menu-item__new-badge">
                {staticTextMenu.getIn(['user', 'newBadge'], 'NEW!')}
              </span>
            </span>
          </span>
        </Link>
      )
    }

    if (isOwner && !portalUrl) {
      return (
        <span className={className}>
          {children}
        </span>
      )
    }

    return (
      <React.Fragment>
        {
          hasPortal
            ? <Link
              className={className}
              onClick={onClick}
              to={url}
            >
              {children}
              <span className="menu-item__view-portal">
                {staticTextViewPortal}
              </span>
              <span className="menu-item__view-portal-icon">
                <IconV2 type={ICON_TYPES.CHEVRON_RIGHT} />
              </span>
            </Link>
            : <Button
              type={TYPES.LINK}
              className={className}
              onClick={onClick}
            >
              {children}
            </Button>
        }
      </React.Fragment>
    )
  }

  renderProfiles () {
    const { props } = this
    const { profiles, auth } = props

    if (profiles) {
      const uid = auth.get('uid')
      const userProfiles = profiles.get('data', List())
      const currentUsersProfile = userProfiles.find((profile) => (
        _parseInt(profile.get('uid')) === uid
      ))
      const otherProfiles = userProfiles.filter((profile) => (
        _parseInt(profile.get('uid')) !== uid
      ))
      const orderedProfiles = currentUsersProfile
        ? otherProfiles.insert(0, currentUsersProfile)
        : otherProfiles
      return orderedProfiles.map((profile) => {
        return (
          <li
            className="menu-item menu__menu-item menu-item--user menu-item--profile"
            key={`menu-item-profile-${profile.get('uid')}`}
          >{this.renderProfile(profile)}
          </li>
        )
      })
    }
    return null
  }

  renderMenuItems () {
    const { props } = this
    const {
      itemLinkClassName = [],
      itemClassName = [],
      itemIconType,
      itemChildren,
      menu,
      isGiftCompatible,
      auth,
      staticTextMenu,
      userLanguage,
    } = props
    const isLoggedIn = getAuthIsLoggedIn(auth)

    // Add the gift path
    if (
      props.ariaId === 'footer__menu-label-1'
      && isGiftCompatible === GIFT_READY_STATE.CAN_PURCHASE
      && menu._tail.array.length < 4
    ) {
      const giftLink = menu._tail.array[0].map((x) => { return { ...x } })
      giftLink._root.entries = [
        ['url', giftMultipleCurrenciesActive ? getGiftLpUrl(userLanguage) : URL_GIFT_LP],
        ['label', staticTextMenu.get('giftSubscription')],
        ['trackingId', null],
      ]
      menu._tail.array.unshift(giftLink)
      menu._capacity = menu._tail.array.length
      menu.size = menu._tail.array.length
    }

    return menu.map((item, index, list) => {
      //
      const linkClassName = [].concat(itemLinkClassName)
      const child = itemChildren ? itemChildren.get(index) : null
      const iconType = child && itemIconType ? itemIconType : null
      const iconArrowClassName = 'menu-item__icon-arrow'
      const iconClasses = []
      const isShopLink = item.get('trackingId') === '181'

      let url = item.get('url')

      if (iconType === MENU_ITEM_ICON_TYPE_ARROW) {
        iconClasses.push(iconArrowClassName)
      }

      if (item.get('active')) {
        linkClassName.push('menu-item__link--active')
      }

      if (item.get('selected')) {
        linkClassName.push('menu-item__link--selected')
      }

      if (item.get('selected') && iconType === MENU_ITEM_ICON_TYPE_ARROW) {
        iconClasses.push(`${iconArrowClassName}--expanded`)
      }

      if (index === 0) {
        linkClassName.push('menu-item__link--first')
      }
      if (item.get('user-menu-border')) {
        linkClassName.push('menu-item__link--border')
      }
      if (index === list.size - 1) {
        linkClassName.push('menu-item__link--last')
      }
      // TODO: Special UserMenu case should move to user menu
      if (index === list.size - 1 && item.get('user-menu-item')) {
        linkClassName.push('menu-item__link--last--user')
      }
      // Marketplace link
      if (isShopLink) {
        if (isLoggedIn) url = URL_MARKETPLACE_LOGGED_IN
      }

      /* eslint-disable react/no-array-index-key */
      return (
        <MenuItem
          key={index}
          index={index}
          iconType={iconType}
          url={url}
          onClick={this.onClick}
          label={item.get('label')}
          target={item.get('target')}
          linkClass={linkClassName.join(' ')}
          iconClassName={iconClasses.join(' ')}
          scrollToTop={isShopLink ? false : item.get('scrollToTop')}
          itemClass={['menu__menu-item'].concat(itemClassName).join(' ')}
        >
          {itemChildren.get(index)}
        </MenuItem>
      )
      /* eslint-enable react/no-array-index-key */
    })
  }

  render () {
    const { props } = this
    const { className, ariaId, profiles } = props
    if (profiles) {
      return (
        <div aria-labelledby={ariaId} className={['menu'].concat(className || []).join(' ')}>
          <ul className="menu__profiles-section">
            {this.renderProfiles()}
          </ul>
          <ul className="menu__items-section">
            {this.renderMenuItems()}
          </ul>
        </div>
      )
    }
    return (
      <ul aria-labelledby={ariaId} className={['menu'].concat(className || []).join(' ')}>
        {this.renderMenuItems()}
      </ul>
    )
  }
}

Menu.propTypes = {
  isGiftCompatible: PropTypes.string,
  clearUpstreamContext: PropTypes.func.isRequired,
  menu: ImmutablePropTypes.list.isRequired,
  itemChildren: ImmutablePropTypes.list,
  itemLinkClassName: PropTypes.string,
  profiles: ImmutablePropTypes.map,
  itemClassName: PropTypes.string,
  itemIconType: PropTypes.string,
  className: PropTypes.string,
  ariaId: PropTypes.string,
  userLanguage: PropTypes.string,
  communityProfilePictures: ImmutablePropTypes.map,
  communityProfileEnabled: PropTypes.bool,
  trackCommunityHeaderLinkClicked: PropTypes.func,
}

Menu.defaultProps = {
  itemChildren: List(),
}

export default connectRedux(
  (state) => ({
    staticTextViewPortal: state.staticText.getIn(['data', 'portal', 'data', 'viewPortal'], ''),
    staticTextMenu: state.staticText.getIn(['data', 'menu', 'data'], Map()),
    communityProfilePictures: selectProfilePicturesMap(state),
    language: state.user.getIn(['data', 'language']),
    userLanguage: getPrimary(state.user.getIn(['data', 'language'])),
    resolver: state.resolver,
    auth: state.auth,
  }),
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      resetOnboarding: actions.onboarding.resetOnboarding,
      clearUpstreamContext: actions.upstreamContext.clearUpstreamContext,
      changeAuthProfile: actions.auth.changeAuthProfile,
    }
  },
)(Menu)
